import type { Integration } from '@getaccept/lib-shared-new/src/integrations/types/integration';
import { ref } from 'vue';
import StripeService from '../../services/stripe.service';

export const useStripe = () => {
  const stripe = ref<Integration>(undefined);
  const error = ref('');

  const loadStripe = async () => {
    try {
      const integration: Integration = await StripeService.getStripeIntegration();
      error.value = '';
      stripe.value = integration;
    } catch (e) {
      error.value = e.message;
    }
  };

  return {
    stripe,
    error,
    loadStripe,
  };
};
